document.addEventListener('DOMContentLoaded',()=>{
    if( document.querySelectorAll('.trynow__button_buy').length > 0 ){
      document.querySelector('.trynow__button_buy span').addEventListener('click', function(evt){
        evt.preventDefault();
        if (!document.querySelector('.ab_test_addbtn.OneClick_Popup').classList.contains('show-checked')) {
          let thisElm = this;
          thisElm.closest('.trynow__button_buy').classList.add('clickedMe');
          var mainID = document.querySelector('.ab_test_addbtn.OneClick_Popup').getAttribute('main-productid'); var mnpQy = document.querySelector('[title="Qty"]').value; var formData = new FormData(); 
          formData.append('quantity', mnpQy); formData.append('id', mainID); fetch('/cart/add.js', { method: 'POST', body: formData }) 
          .then(response => { if (!response.ok) { throw new Error('Network response was not ok'); } return response.json(); }) 
          .then(data => {
            thisElm.closest('.trynow__button_buy').classList.remove('clickedMe');
            if (window.HumeCart && window.HumeCart.active) { window.HumeCart.open(); }
            else { window.location.href = '/checkout'; } 
          }) 
        }else if(document.querySelector('.ab_test_addbtn.OneClick_Popup').classList.contains('WarrantyDisabledPopup')){
          let thisElm = this;
          thisElm.closest('.trynow__button_buy').classList.add('clickedMe');
          var mainID = document.querySelector('.ab_test_addbtn.OneClick_Popup').getAttribute('data-without-popup'); var mnpQy = document.querySelector('[title="Qty"]').value; var formData = new FormData(); 
          formData.append('quantity', mnpQy); formData.append('id', mainID); fetch('/cart/add.js', { method: 'POST', body: formData }) 
          .then(response => { if (!response.ok) { throw new Error('Network response was not ok'); } return response.json(); }) 
          .then(data => {
            thisElm.closest('.trynow__button_buy').classList.remove('clickedMe');
            if (window.HumeCart && window.HumeCart.active) { window.HumeCart.open(); }
            else { window.location.href = '/checkout'; }
          })      
        }else{
          document.querySelector('.Product_Popup').classList.add('popup-open'); document.body.classList.add('popup-show');
        }
      })  
    }

    document.querySelectorAll('[js-popup-trynow]').forEach((el)=>{
        el.addEventListener('click', (target)=>{
            target.preventDefault();
            document.body.classList.add('overflow-hidden');
            document.querySelector('.trynowpopup__mainwrapped').classList.add('active');
        })
    });

    document.querySelectorAll('[js-popup-trynow-close]').forEach((el)=>{
        el.addEventListener('click', (target)=>{
            target.preventDefault();
            document.body.classList.remove('overflow-hidden');
            document.querySelector('.trynowpopup__mainwrapped').classList.remove('active');
        })
    });    
    
})